import { render } from "./CurrentUserName.vue?vue&type=template&id=48d72d1e&scoped=true"
import script from "./CurrentUserName.vue?vue&type=script&lang=ts"
export * from "./CurrentUserName.vue?vue&type=script&lang=ts"

import "./CurrentUserName.vue?vue&type=style&index=0&id=48d72d1e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-48d72d1e"

export default script